<template>
  <div>
    <div>
      <div class="bg-secondary-3 rounded my-2 py-4 px-5 my-4">
        <div class="row">
          <div class="col-12 my-4 d-flex justify-content-between">
            <div class="badge badge-pill bg-white py-2 px-4 border">
              <div
                class="dot mr-3"
                :class="StatusColor(model.signatureStatusId)"
              ></div>
              <span class="font-16">{{
                StatusName(model.signatureStatusId)
              }}</span>
            </div>
            <div>
              <button
                v-if="ShowOptions(model.signatureStatusId)"
                id="btn-signature"
                class="btn btn-outline-success btn-dropdown-actions dropdown-toggle float-right pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="px-2">Acciones</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="peiTabsHeaderDD"
              >
                <!-- Completar -->
                <div
                  id="complete-pei"
                  class="dropdown-item"
                  @click="$emit('send-email', model)"
                >
                  <i class="fas fa-envelope text-green pr-1"></i>
                  <span>Enviar Email</span>
                </div>
                <div
                  id="complete-pei"
                  class="dropdown-item"
                  @click="$emit('copy')"
                >
                  <i class="fas fa-copy text-green pr-1"></i>
                  <span>Copiar Enlace</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="border" />
        <div class="row mt-4">
          <div class="col-12 col-md-3">
            <label class="text-gray font-14">Puesto:</label>
            <p class="font-16">{{ model.position }}</p>
          </div>
          <div class="col-12 col-md-3">
            <label class="text-gray font-14">Nombre:</label>
            <p class="font-16">{{ model.fullName }}</p>
          </div>
          <div class="col-12 col-md-3">
            <label class="text-gray font-14">Tipo de Firma:</label>
            <p class="font-16">Electrónica</p>
          </div>
          <div v-if="!isEditMode" class="col-12 col-md-3">
            <label class="text-gray font-14">Usuario/Correo Electrónico:</label>
            <p class="font-16">{{ (model.username != null ? model.username+'/' : '')+model.email }}</p>
          </div>
          <div v-if="isEditMode" class="col-12 col-md-3 d-flex">
            <validation-observer ref="form">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                :custom-messages="{
                  required: 'El correo electrónico es requerido.',
                  email: 'El correo electrónico no es válido.'
                }"
              >
                <CustomInput
                  id="input-email"
                  v-model="model.email"
                  label="Correo Electrónico:"
                  type="text"
                  placeholder=""
                  :error="errors[0]"
                />
              </ValidationProvider>
            </validation-observer>
            <div
              class="d-flex justify-content-end align-items-center mt-4 ml-4"
            >
              <action-button
                type="button"
                i="fas fa-times-circle"
                variant="outline-danger"
                class="ml-2"
                @click="toggleEditMode(false)"
              />
              <action-button
                type="button"
                i="fas fa-save"
                variant="success"
                class="ml-2"
                @click="update"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}
.bg-yellow {
  background-color: $yellow;
}
.bg-orange {
  background-color: #f3ae81;
}
</style>

<script>
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import SectionTitle from "SectionTitle";
import alert from "@/mixin/alert.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { SignatureStatus } from "@/utils/constants/signature/signatureStatus";

export default {
  name: "Participant",
  components: {
    ActionButton,
    SectionTitle,
    CustomInput,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEditMode: false
    };
  },
  methods: {
    toggleEditMode(value) {
      this.isEditMode = value;
    },
    async update() {
      let isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.ShowToast(
          "Alerta",
          "Favor completar la información solicitada.",
          "error"
        );
        return;
      }
      this.isEditMode = false;
      this.$emit("update");
    }
  },
  computed: {
    StatusName() {
      return statusId => {
        if (statusId == null) return "No Disponible";
        if (statusId === SignatureStatus.Signed) return "Firmado";
        return "No firmado";
      };
    },
    StatusColor() {
      return statusId => {
        if (statusId == null) return "bg-yellow";
        if (statusId === SignatureStatus.Signed) return "bg-orange";
        return "bg-yellow";
      };
    },
    ShowOptions() {
      return statusId => {
        return statusId === SignatureStatus.UnSigned;
      };
    },
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
